import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class GlobalFields {
  public static controls = {
    seabedDepth: {
      title: 'Depth',
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_MORE_THAN_ZERO,
    },
    gravity: {
      title: 'Gravity',
      quantity: UnitConstants.QUANTITY.ACCELERATION,
      validator: TERMS.REQUIRED_MORE_THAN_ZERO,
    },
    waterSpecificWeight: {
      title: 'Water Specific Weight',
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      validator: TERMS.REQUIRED_MORE_THAN_ZERO,
    },
  };
}
